<div class="ui-extra-products-collapse-container"
     [class.expand]="isExpand">
  <div class="ui-extra-products-compensator">
    <div class="ui-extra-products-collapse-wrap"
         [style.height.px]="contentHeight"
         #wrap>
      <div class="ui-extra-products-collapse-content" #content>
        <div class="radio-extra-wrap">
          <ng-container *ngFor="let item of items; let ind = index">
            <div class="d-flex justify-content-between align-items-center radio-label-wrap"
                 [class.position-relative]="isShowOverlay(ind)"
                 [class.show-radio]="isShowExtraProduct(ind)">
              <div>
                <label class="radio-item-extra radio-primary" [class.active]="model?.id === item?.value.id">
                  <input type="radio" [value]="item.value.id" (click)="$event.stopPropagation();model = item.value">
                  <div class="radio-mark-extra">

                    <i class="radio-mark-extra-icon icon-radiobox-blank"></i>
                    <i class="radio-mark-extra-icon icon-radiobox-marked"></i>

                    <div class="font-lg">
                      <span class="fw-bold">{{ item.label }}</span>
                      <span *ngIf="!item.hidePrice && item.priceLabel">, + {{ item.priceLabel }}</span>
                    </div>
                    <div class="font-sm text-muted" *ngIf="item.value?.description">
                      {{ item.value.description }}
                    </div>
                  </div>
                </label>
              </div>
              <div *ngIf="showPictures && item.value?.picture">
                <div class="ui-extra-products-img">
                  <img (click)="$event.stopPropagation(); selectImage(item.value.picture, $event)"
                       [src]="item.value?.picture | multiImage: 'smallUrl' : true : '/assets/img/content/default-cake-image.jpg'">
                </div>
              </div>
              <div class="ui-collapser-overlay" *ngIf="isShowOverlay(ind)"></div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="ui-extra-products-collapser"
       *ngIf="!isExpand">
    <div class="ui-extra-show-hide-btn"
         (click)="$event.stopPropagation(); toggle();">
      <span class="fw-bold" [translate]="'cakeBuilder.extraProductsSection.showMore'">Show more</span>
      <i class="icon-chevron-down text-pink"></i>
    </div>
  </div>

  <div *ngIf="model && model.id !== undefined"
       class="text-blue-2 pointer font-sm p-2 fw-bold"
       [translate]="'cakeBuilder.extraProductsSection.clearChoice'"
       (click)="clearChoice()">
  </div>
</div>
